module.exports = __webpack_public_path__ + "media/assets/services_manager/mail_grey-bb0ae7d4edca9917c6740be869cafeeef31dc727e98144132473d206afa28a1b.svg";